module.exports = __webpack_public_path__ + "img/435be63.jpg";